import { QueryState } from 'common/enums';
import { Nullable } from 'common/utils/Nullable';

export interface IUpdatePlanState {
  state: QueryState;
  error: Nullable<string>;
  accessToken: string | undefined;
  isEmailDuplicate: boolean;
}

export const UpdatePlanEmptyState: IUpdatePlanState = {
  state: QueryState.UNDEFINED,
  error: null,
  accessToken: undefined,
  isEmailDuplicate: false
};
